class PdpVariants extends HTMLElement {
    constructor() {
        super();
        this.variants = [];
        this.lastInteractedElement = null;
    }

    connectedCallback() {
        this.container = this.closest('.shopify-section');

        // Find the <script type="application/json"> inside this element
        const script = this.querySelector('script[type="application/json"]');
        if (script) {
            try {
                this.variants = JSON.parse(script.textContent.trim());

                // Get form element from variant-picker in the same section
                const variantPicker = this.container.querySelector('.shopify-section--main-product variant-picker');
                this._form = document.forms[variantPicker?.getAttribute("form-id")];

                // Listen for variant:change event on form
                this._form?.addEventListener('variant:change', this._onVariantChanged.bind(this));
                this._form?.addEventListener('option:change', this._onOptionChanged.bind(this));
            } catch (e) {
                console.error('Failed to parse variants JSON:', e);
            }
        } else {
            console.warn('No <script type="application/json"> found inside <pdp-variants>');
        }
    }

    disconnectedCallback() {
        if (this._form) {
            this._form.removeEventListener('variant:change', this._onVariantChanged);
            this._form.removeEventListener('option:change', this._onOptionChanged);
        }

        // Clear references
        this.lastInteractedElement = null;
        this._form = null;
        this.variants = [];
    }

    _onVariantChanged(event) {
        const { variant } = event.detail;

        if (variant) return;

        this._handleUnvailableVariant();
    }

    _onOptionChanged(evt) {
        const { event } = evt.detail;
        this.lastInteractedElement = event.target;
    }
    _handleUnvailableVariant() {
        const target = this.lastInteractedElement;
        if (!target?.hasAttribute('data-option-position')) return;

        const nextVariant = this.variants.find(variant => variant.options.find(option => +option.position === +target.getAttribute('data-option-position') && option.id.toString() === target.value.toString()));

        if (!nextVariant) return;

        this._handleChangeAvailableVariant(nextVariant);
    }

    _handleChangeAvailableVariant(variant) {
        let lastInteractedElement = null;
        variant.options.forEach(option => {
            const target = Array.from(this.container.querySelectorAll(`[data-option-position="${option.position}"]`)).find(input => input.value.toString() === option.id.toString());
            if (target) {
                target.tagName == 'INPUT' && (target.checked = true);
                target.tagName == 'SELECT' && (target.value = option.id);
                lastInteractedElement = target;
            }
        });

        if (lastInteractedElement) {
            lastInteractedElement.dispatchEvent(new Event('change', { bubbles: true }));
            lastInteractedElement.dispatchEvent(new Event('input', { bubbles: true }));
            lastInteractedElement.dispatchEvent(new Event('focus', { bubbles: true }));
            lastInteractedElement.dispatchEvent(new Event('click', { bubbles: true }));
        }
    }
}

if (!window.customElements.get('pdp-variants')) {
    window.customElements.define('pdp-variants', PdpVariants);
}
